import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="container space">
      <div >

        {/* Main Heading */}
        <h1 className="text-center fw-bold mb-5">Terms and Conditions</h1>

        {/* Intro */}
        <p className="text-muted mb-4">
          Welcome to <strong>AEPSPay</strong>. By accessing or using our website
          and services, you agree to comply with and be bound by the following
          Terms and Conditions. Please read them carefully before using our
          platform.
        </p>

        {/* 1 */}
        <h4 className="fw-bold mt-4">1. Definitions</h4>
        <p className="text-muted">
          <strong>“Company”, “We”, “Us”, “Our”</strong> refers to AEPSPay.
          <br />
          <strong>“User”, “You”, “Your”</strong> refers to any individual,
          retailer, distributor, partner, or entity accessing or using our
          services.
          <br />
          <strong>“Services”</strong> refers to all digital services provided
          through AEPSPay including AEPS transactions, DMT, recharges, bill
          payments, APIs, and related software.
        </p>

        {/* 2 */}
        <h4 className="fw-bold mt-4">2. Services Offered</h4>
        <p className="text-muted">
          AEPSPay provides digital payment and financial services including
          Aadhaar Enabled Payment System (AEPS), Cash Withdrawal, Cash Deposit,
          Mini Statement, Balance Enquiry, Domestic Money Transfer (DMT),
          Utility Bill Payment, AEPS Software, AEPS API Integration, and other
          related services. All services are provided through authorized
          banking partners, payment gateways, and financial institutions.
        </p>

        {/* 3 */}
        <h4 className="fw-bold mt-4">3. Eligibility</h4>
        <ul className="mb-3">
          <li>You must be at least 18 years old.</li>
          <li>You must provide accurate and complete information during registration.</li>
          <li>You agree to comply with RBI, NPCI, UIDAI, and other regulatory guidelines applicable in India.</li>
          <li>We reserve the right to refuse service if eligibility requirements are not met.</li>
        </ul>

        {/* 4 */}
        <h4 className="fw-bold mt-4">4. User Responsibilities</h4>
        <ul className="mb-3">
          <li>You will not use the platform for fraudulent or illegal activities.</li>
          <li>You will maintain confidentiality of login credentials.</li>
          <li>You will not attempt to hack, reverse engineer, or misuse the system.</li>
          <li>You will comply with financial regulations and KYC requirements.</li>
          <li>You are responsible for all activities performed through your account.</li>
        </ul>

        {/* 5 */}
        <h4 className="fw-bold mt-4">5. Transaction Processing</h4>
        <p className="text-muted">
          Transactions performed through AEPSPay are processed through banking
          and payment partners. We do not guarantee instant success of every
          transaction. Failed or pending transactions will follow bank
          settlement timelines. AEPSPay shall not be responsible for delays
          caused by banks, NPCI, UIDAI, or network providers.
        </p>

        {/* 6 */}
        <h4 className="fw-bold mt-4">6. Fees and Charges</h4>
        <p className="text-muted">
          Certain services may include transaction fees or commissions. All
          applicable charges will be communicated through the platform.
          AEPSPay reserves the right to modify fees at any time with notice.
        </p>

        {/* 7 */}
        <h4 className="fw-bold mt-4">7. Refund and Reversal Policy</h4>
        <p className="text-muted">
          Refunds for failed transactions will be processed as per banking
          partner policies. Refund timelines may vary depending on the payment
          network or bank and working hours. AEPSPay is not responsible for
          delays caused by third-party financial institutions.
        </p>

        {/* 8 */}
        <h4 className="fw-bold mt-4">8. Prohibited Activities</h4>
        <ul className="mb-3">
          <li>Conduct fraudulent AEPS or Aadhaar transactions</li>
          <li>Use stolen Aadhaar or bank credentials</li>
          <li>Perform money laundering or illegal fund transfers</li>
          <li>Misuse the AEPSPay API or software</li>
          <li>Disrupt or attempt to damage the platform</li>
        </ul>
        <p className="text-muted">Violation may result in account suspension and legal action.</p>

        {/* 9 */}
        <h4 className="fw-bold mt-4">9. API and Software Usage</h4>
        <p className="text-muted">
          API access is granted for authorized integration only. Users may not
          resell, copy, or redistribute the software without written
          permission. Abuse of API services may lead to termination of access.
        </p>

        {/* 10 */}
        <h4 className="fw-bold mt-4">10. Intellectual Property</h4>
        <p className="text-muted">
          All content on AEPSPay including software, website design, logos,
          branding, and APIs are the intellectual property of AEPSPay and may
          not be copied or reproduced without written consent.
        </p>

        {/* 11 */}
        <h4 className="fw-bold mt-4">11. Limitation of Liability</h4>
        <p className="text-muted">
          AEPSPay shall not be liable for banking network failures, NPCI or
          UIDAI service outages, incorrect information entered by users,
          third-party service interruptions, or financial losses caused by
          user negligence. Use of our services is at your own risk.
        </p>

        {/* 12 */}
        <h4 className="fw-bold mt-4">12. Account Suspension or Termination</h4>
        <p className="text-muted">
          We reserve the right to suspend or terminate accounts if fraudulent
          activity is detected, regulatory guidelines are violated, false
          information is provided, or misuse of services occurs.
        </p>

        {/* 13 */}
        <h4 className="fw-bold mt-4">13. Compliance with Laws</h4>
        <p className="text-muted">
          Users must comply with all applicable Indian laws including the
          Information Technology Act, 2000, RBI regulations, NPCI guidelines,
          and UIDAI regulations for Aadhaar authentication.
        </p>

        {/* 14 */}
        <h4 className="fw-bold mt-4">14. Changes to Terms</h4>
        <p className="text-muted">
          AEPSPay reserves the right to modify these Terms and Conditions at
          any time. Updated terms will be posted on the website. Continued use
          of the platform after updates constitutes acceptance of the revised
          terms.
        </p>

        {/* 15 */}
        <h4 className="fw-bold mt-4">15. Contact Information</h4>
        <p>
          If you have any questions regarding these Terms and Conditions please{" "}
          <a href="/contact" className="fw-semibold text-primary">
            Contact Us
          </a>
          .
        </p>

      </div>
    </div>
  );
};

export default TermsAndConditions;